module.exports = __webpack_public_path__ + "static/media/0098_Medium.44c4bb47.jpg";